import { Control, FieldValues, Path } from 'react-hook-form';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { MultiSelect as MultiSelectComponent } from '@/components/ui/multi-select';
import { cn } from '@/lib/utils';

import { OptionType } from '../types';

export type MultiSelectProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  options: OptionType[];
  label?: string;
  placeholder?: string;
  className?: string;
  loading?: boolean;
  maxCount?: number;
  requiredMark?: boolean;
};

export const MultiSelect = <T extends FieldValues>({
  name,
  control,
  options,
  className,
  placeholder,
  label,
  loading,
  maxCount,
  requiredMark,
}: MultiSelectProps<T>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field, formState: { errors } }) => {
        return (
          <FormItem className={className}>
            <FormControl>
              <div className="grid gap-3">
                {label && (
                  <FormLabel
                    htmlFor={name}
                    className={cn(
                      'text-sm font-medium',
                      field.disabled && 'pointer-events-none'
                    )}
                  >
                    {label}
                    {requiredMark && <span className="text-red-500">*</span>}
                  </FormLabel>
                )}
                <MultiSelectComponent
                  options={options}
                  disabled={field.disabled}
                  onValueChange={field.onChange}
                  placeholder={placeholder}
                  value={field.value ?? []}
                  defaultValue={field.value ?? []}
                  loading={loading}
                  maxCount={maxCount}
                  error={!!errors[name]?.message}
                />
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
